<script setup lang="ts">
withDefaults(
  defineProps<{
    label?: string
    today?: boolean
    disabled?: boolean
  }>(),
  {
    label: '',
    today: false,
  },
)
</script>

<template lang="pug">
.weekday.typ-14-20-500.flex-center-center.w-40.h-30(:class="{ today: today && !disabled, disabled }" :aria-disabled="disabled || undefined")
  | {{ label }}
</template>

<style scoped>
.weekday {
  text-transform: capitalize;
  color: var(--cue-content-neutral-secondary);

  &.today {
    color: var(--cue-content-error-default);
  }

  &.disabled {
    color: var(--cue-content-neutral-disabled);
  }
}
</style>
